import { createContext, useContext, useState } from "react";
import { AuthContext } from "./auth";


export const DataRegistrationContext = createContext()

function ContextRegistrationProvider({children}){
    const [showPopEmail, setShowPopEmail] = useState(false)
    const [messageEmail, setMessageEmail] = useState("")
    const [showPopAdmin, setShowPopAdmin] = useState(false)
    const {setUser} = useContext(AuthContext)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password_confirmation, setPassword_confirmation] = useState('')
    const [company, setCompany] = useState('')
    const [phone, setPhone] = useState('')
    const [state, setState] = useState('')
    const [number_of_employees, setNumber_of_employees] = useState('')
    const [company_type_id, setCompany_type_id] = useState('')
    const [type_capital_id, setType_capital_id] = useState('')
    const [annual_billing_id, setAnnual_billing_id] = useState('')
    const [company_role_id, setCompany_role_id] = useState('')

    function registrationClient(){
        const headers = {
            "Content-Type": "application/json",
            "Accept": "application/json",
        };

        let body = {
            "user": {
                "name": name,
                "email": email,
                "password": password,
                "password_confirmation": password_confirmation
            },
            "company_data": {
                "company": company,
                "phone": phone,
                "state": state,
                "number_of_employees": parseInt(String(number_of_employees).replace(/\D/g, ''), 10),
                "terms": 1,
                "company_type_id": company_type_id,
                "capital_type_id": type_capital_id,
                "annual_billing_id": annual_billing_id,
                "company_role_id": company_role_id
            }
        };

        fetch(`${process.env.REACT_APP_API_URL}/register`, {
            method: "POST",
            headers,
            body: JSON.stringify(body),
        })
        .then(async response => {
            const data = await response.json().catch(() => ({}));
            
            if(response.status === 422){
                setMessageEmail(data.message || data.error || "O e-mail informado já está sendo utilizado. Por favor, registre um diferente.");
                setShowPopEmail(true);
                return;
            }
            if(response.status === 201){
                setShowPopAdmin(true);
                if (data.token && data.token.access_token) {
                    localStorage.setItem('@token', data.token.access_token);
                    localStorage.setItem('@user', JSON.stringify(data.user));
                    setUser(data.user);
                }
                return;
            }
        })
        .catch(error => {
            console.error(error)
        })
    }

    return(
        <DataRegistrationContext.Provider value={{registrationClient,
         email, setEmail, name, setName, password, setPassword, password_confirmation, setPassword_confirmation,
          company, setCompany, phone, setPhone, state, setState, company_type_id, setCompany_type_id,
          type_capital_id, setType_capital_id, annual_billing_id, setAnnual_billing_id,
          company_role_id, setCompany_role_id,
          number_of_employees, setNumber_of_employees, showPopEmail, setShowPopEmail, messageEmail, setMessageEmail, showPopAdmin, setShowPopAdmin}}>
            {children}
        </DataRegistrationContext.Provider>
    )
}

export default ContextRegistrationProvider;
